import React from 'react';
import { components, OptionProps } from 'react-select';
import InputWrapper, { extractWrapperProps, ExtractableInputWrapperProps } from '../utils/InputWrapper';
import NakedSelect from './NakedSelect';
import NakedFilterSelect from './NakedFilterSelect';
import { NakedSelectProps } from './SelectTypes';

export interface SelectProps extends NakedSelectProps, ExtractableInputWrapperProps {
    variant?: 'filter' | 'default';
}

Select.DefaultProps = {
    variant: 'default',
};

export function Select(props: SelectProps): JSX.Element {
    const { extractedProps: wrapperProps, otherProps: selectProps } = extractWrapperProps<SelectProps>(props);
    return (
        <InputWrapper {...wrapperProps}>
            {selectProps.variant == 'filter' ? (
                <NakedFilterSelect {...{ ...selectProps, isError: wrapperProps.isError }} />
            ) : (
                <NakedSelect {...{ ...selectProps, isError: wrapperProps.isError }} />
            )}
        </InputWrapper>
    );
}
export { NakedSelect };
export const OptionComponent = components.Option;
export type OptionComponentProps = OptionProps<any, any, any>;
export type { SelectOptionType } from './SelectTypes';
